<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="22"
    viewBox="0 0 21 22"
    fill="none"
  >
    <g
      id="Staging-white"
      clip-path="url(#clip0_25601_14714)"
    >
      <path
        id="Vector"
        d="M11.1729 20.0565C11.1729 20.6895 11.1729 21.0059 11.3051 21.1824C11.4203 21.3362 11.5967 21.4323 11.7884 21.4457C12.0083 21.4611 12.2742 21.2895 12.806 20.9463L16.9622 18.2638C18.0247 17.5782 18.5559 17.2353 18.9409 16.7768C19.2816 16.3708 19.5377 15.9008 19.694 15.3944C19.8705 14.8223 19.8705 14.19 19.8705 12.9255V8.57932C19.8705 7.95089 19.8705 7.63665 19.7391 7.46053C19.6245 7.30707 19.4491 7.21074 19.2582 7.19641C19.0391 7.17994 18.7739 7.34851 18.2435 7.68565L11.6637 11.8678C11.4845 11.9818 11.3948 12.0388 11.3298 12.1154C11.2723 12.1833 11.229 12.262 11.2026 12.347C11.1729 12.4429 11.1729 12.5491 11.1729 12.7615V20.0565Z"
        fill="currentColor"
      />
      <path
        id="Vector_2"
        d="M2.03268 7.61447C1.5077 7.29934 1.24521 7.14177 1.02923 7.16186C0.840898 7.17935 0.669064 7.27662 0.557108 7.42908C0.428711 7.60395 0.428711 7.9101 0.428711 8.52236V12.8188C0.428711 14.1205 0.428711 14.7713 0.6144 15.357C0.778732 15.8754 1.04777 16.3544 1.40483 16.7645C1.80829 17.2279 2.36402 17.5666 3.47546 18.2441L8.02793 21.019C8.55432 21.3399 8.81755 21.5003 9.0344 21.4812C9.22342 21.4645 9.39621 21.3675 9.50882 21.2148C9.63803 21.0396 9.63803 20.7313 9.63803 20.1148V12.7794C9.63803 12.5608 9.63803 12.4516 9.60663 12.3533C9.57893 12.2664 9.5335 12.1862 9.47327 12.1177C9.40519 12.0402 9.31148 11.984 9.12412 11.8715L2.03268 7.61447Z"
        fill="currentColor"
      />
      <path
        id="Vector_3"
        d="M7.11835 1.98749C8.31307 1.2652 8.9104 0.904058 9.54863 0.763002C10.1131 0.638244 10.698 0.638244 11.2626 0.763002C11.9008 0.904052 12.4981 1.2652 13.6928 1.98749L17.8487 4.50007C18.3469 4.80126 18.596 4.95185 18.68 5.14579C18.7533 5.31506 18.7527 5.50726 18.6782 5.67604C18.5929 5.86941 18.3428 6.01829 17.8426 6.31612L10.9474 10.4217C10.7503 10.5391 10.6518 10.5977 10.5467 10.6206C10.4537 10.6409 10.3575 10.6409 10.2645 10.6206C10.1594 10.5977 10.0609 10.5391 9.86383 10.4217L2.96858 6.31612C2.46839 6.01829 2.2183 5.86941 2.13298 5.67604C2.05851 5.50726 2.05787 5.31506 2.1312 5.14579C2.21521 4.95185 2.46429 4.80126 2.96246 4.50007L7.11835 1.98749Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_25601_14714">
        <rect
          width="19.6216"
          height="22"
          fill="currentColor"
          transform="translate(0.428711)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
}
</script>
